import { render, staticRenderFns } from "./classData.vue?vue&type=template&id=ffcaf1c2&scoped=true&"
import script from "./classData.vue?vue&type=script&lang=js&"
export * from "./classData.vue?vue&type=script&lang=js&"
import style0 from "./classData.vue?vue&type=style&index=0&id=ffcaf1c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcaf1c2",
  null
  
)

export default component.exports